import React from 'react';
import { TextField, RadioButton, RadioButtonGroup } from '@framework-controls/core';
import SVPButton from 'src/components/SVPButtons/SVPButton';
import { strings } from 'src/localization/index';
import { diagnoseResponses } from '../../DiagnoseTreeLit/DiagnoseTreeLit';
import css from './MobileDiagnoseContent.module.scss';


interface IProps {
    endDialogTree: boolean;
    // otherResponse is true when the 'Other' option is selected
    otherResponse: boolean;
    // The title of the currently selected dialog option
    title: string;
    // The list of responses attached to the currently selected dialog option
    responses: diagnoseResponses[];
    // The additional comments added alongside the selected issue, also used for entering a custom issue
    additionalComments: string;
    onChangeHandler: (value: string) => void;
    // Passes up the selected diagnose item's title
    addHandler: (value: string) => void;
    // Contains the currently selected button if one exists
    selectedButton: string;
    selectButtonHandler: (value: string) => void;
    theme?: string;
}

const MobileDiagnoseContent = (props: IProps) => {
    // If we are at the end of the dialog tree display additional comments/add diagnosis logic.
    if (props.endDialogTree) {
        // If 'Other' response adjust displayed text and don't display the Final Issue box
        if (props.otherResponse) {
            return (
                <div>
                    <div id='title'>{props.title}</div>
                    <div className={css.comments}>
                        <TextField
                            value={props.additionalComments}
                            id='other'
                            size='full'
                            multiline
                            onChange={(_, value) => props.onChangeHandler(value)}
                            type='text'
                            rows={5}
                            disableUnderline
                        />
                    </div>
                    <SVPButton
                        id='addDiagnosisBtn'
                        message={strings.AddDiagnosisButton}
                        variant='secondaryBtn'
                        // plus
                        noArrow
                        handler={() => props.addHandler(props.additionalComments)}
                        theme={props.theme}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <h3 className={css.bottomBorder}>{strings.ConfirmIssue}</h3>
                    <p>{strings.YourIssue}</p>
                    <div className={css.finalIssue}>
                        <p id='title'>{props.title}</p>
                    </div>
                    <p>{strings.AnyAdditional}</p>
                    <div className={css.comments}>
                        <TextField
                            value={props.additionalComments}
                            id='comments'
                            size='full'
                            multiline
                            onChange={(_, value) => props.onChangeHandler(value)}
                            type='text'
                            rows={5}
                            disableUnderline
                        />
                    </div>
                    <SVPButton
                        id='addDiagnosisBtn'
                        message={strings.AddDiagnosisButton}
                        variant='secondaryBtn'
                        // plus
                        noArrow
                        handler={() => props.addHandler(props.title)}
                        theme={props.theme}
                    />
                </div>
            );
        }
        // If not at the end of the dialog tree display all responses as radio buttons
    } else {
        const diagnoseTree = props.responses.map((item, index) => {
            let optionSpan = <span>{item.option}</span>;
            // Split the option string for underlining
            if (item.underlined) {
                const splitOption = item.option.split(item.underlined);
                optionSpan = (
                    <React.Fragment>
                        <span>{splitOption[0]}</span>
                        <span className={css.underlined}>{item.underlined}</span>
                        <span>{splitOption[1]}</span>
                    </React.Fragment>
                );
            }

            return (
                <div key={index} className={css.radioButton}>
                    <RadioButton
                        value={index.toString()}
                        color={index.toString() === props.selectedButton ? 'secondary' : 'default'}
                    />
                    {optionSpan}
                </div>
            );
        });

        return (
            <div className={css.topBottomBorder}>
                <RadioButtonGroup
                    value={props.selectedButton}
                    id='current'
                    onChange={(_, value) => props.selectButtonHandler(value)}
                >
                    {diagnoseTree}
                </RadioButtonGroup>
            </div>
        );
    }
};

export default MobileDiagnoseContent;